/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-22 14:26:16
 * @LastEditors: wuzuojie 15727841808@163.com
 * @LastEditTime: 2023-07-31 15:51:37
 */
export const drRouter = [
	'/index',
	'/index/home',
	'/shopManage',
	'/shopManage/shopLibrary',
	'/shopManage/shopLibrary/list',
	'/shopManage/shopLibrary/shopLibraryDetails',
	'/shopManage/shopGroup',
	'/shopManage/shopGroup/group',
	'/shopManage/shopGroup/record',
	'/shopManage/shopGroup/detail',
	'/shopManage/shopGroup/detail/list',
	'/shopManage/shopGroup/detail/shopDetails',
	'/shopManage/shopLibrary/record',
	'/talentCRM',
	'/talentCRM/index',
	'/cooperationProgress',
	'/cooperationProgress/list',
	'/cooperationProgress/details',
	'/cooperationProgress/record',
	'/extenTecord',
	'/extenTecord/list',
	'/extenTecord/details',
	'/extenTecord/details/list',
	'/extenTecord/details/shopDetails',
	'/talentCRM',
	'/talentCRM/clueSeas',
	'/talentCRM/myTalent',
	'/talentCRM/contacts',
	'/talentCRM/emphasisTalent',
	'/talentCRM/myTalent/importLog',
	'/talentCRM/emphasisTalent/importLog',
	'/talentCRM/groupSeas/importLog',
	'/talentCRM/groupSeas',
	'/personal',
	'/personal/center',
	'/sample',
	'/sample/list',
	'/sample/importLog',
	'/order',
	'/order/list',
	'/order/record',
	'/secondColonelManage',
	'/secondColonelManage/releasePlatform',
	// "/secondColonelManage/colonelActivitySquare",
	// "/secondColonelManage/colonelActivitySquare/list",
	// "/secondColonelManage/colonelActivitySquare/detail",
	// "/secondColonelManage/myActivities",
	// "/secondColonelManage/myActivities/list",
	// "/secondColonelManage/myActivities/detail",
	'/secondColonelManage/cooperativeColonel',
	'/secondColonelManage/cooperativeColonel/list',
	'/secondColonelManage/cooperativeColonel/detail',
	'/ranking',
	'/ranking/issueTalent',
	'/ranking/issueProduct',
	'/ranking/issueHeader',
	'/ranking/record',
];
